import { getAPIUrl } from "shared/utils/api-utils";

export const OPENAI_REALTIME_SESSION_ENDPOINT = `${getAPIUrl("ai")}/openai/realtime-session`;

export const DUCK_CHAT_V1_ROUTE = "/pydanticai/chat";
export const DUCK_CHAT_V2_ROUTE = "/pydanticai/v2/chat";

export const CHAT_ENDPOINT_QUERY_PARAMS = {
  include_all_types: "true",
} as const;

// applied only when the run is in safe mode, so it stays out of CHAT_ENDPOINT_QUERY_PARAMS
export const SAFE_MODE_QUERY_PARAM = "safe_mode";
